import { Component, computed, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { LoginComponent } from 'src/app/components/login/login.component';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  imports: [
    LoginComponent,
    RouterLink,
    MatButton
]
})
export class HomeComponent {
  private authService = inject(AuthService);
  
  readonly canViewHistory = computed(() => {
    this.authService.accountInfo();
    return this.authService.isInRole('FullTrackers');
  });
  
  readonly isAuthenticated = computed(() => this.authService.isAuthenticated());
}